module.exports = __webpack_public_path__ + "static/media/oberflex-eucalyptus-2560x1440.257c1396.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-eucalyptus-2560x1440.jpg
// module id = 1007
// module chunks = 37